// Copyright (c) AdCritter. All rights reserved.

import React, { FC } from 'react'

import { EuiSpacer, EuiText, EuiTitle } from '@elastic/eui'

import AIPlannerMarkdownRenderer from 'pages/MasterCampaignPlanPage/new/components/AIPlannerMarkdownRenderer'

interface MarketAnalysisField {
  key: string
  label: string
  value?: string
}

interface ReadOnlyMarketAnalysisSectionProps {
  fields: MarketAnalysisField[]
}

const ReadOnlyMarketAnalysisSection: FC<ReadOnlyMarketAnalysisSectionProps> = ({ fields }) => {
  return (
    <>
      {fields.map((field, idx) => (
        <React.Fragment key={field.key}>
          {idx > 0 && <EuiSpacer size='m' />}
          <EuiTitle size='s'>
            <h3>{field.label}</h3>
          </EuiTitle>
          <EuiSpacer size='xs' />
          {field.value ? (
            <AIPlannerMarkdownRenderer content={field.value} />
          ) : (
            <EuiText size='s'>
              <p>{'\u2014'}</p>
            </EuiText>
          )}
        </React.Fragment>
      ))}
    </>
  )
}

export default ReadOnlyMarketAnalysisSection
